<!-- The add app modal -->
<div class="modal-content">
  <!-- Modal Header -->
  <div class="modal-header">
    <div class="modal-header-left">
      <h4 class="modal-title">Add Application</h4>
    </div>
    <div class="modal-header-right">
      <button type="button" class="close" (click)="close()">
        <i class="icon-close"></i>
      </button>
    </div>
  </div>
  <!-- Modal body -->
  <form
    class="modal-body"
    [formGroup]="applicationForm"
    (ngSubmit)="onSubmit()"
  >
    <div class="modal-body-inner">
      <div class="form-custom-div">
        <div class="row">
          <div class="col-lg-12 col-md-12" *ngIf="isSuperadmin()">
            <app-select
              [form]="applicationForm"
              [options]="getCompanies()"
              label="Company"
              controlName="CompanyKey"
            ></app-select>
          </div>
          <div class="col-lg-12 col-md-12">
            <app-input
              [form]="applicationForm"
              label="Application Name"
              placeholder="Enter application name"
              controlName="Name"
            ></app-input>
          </div>
          <div class="col-lg-12 col-md-12">
            <div class="form-group">
              <label>Choose Icon</label>
              <div class="default-icon-list-div">
                <div class="default-icon-list-root">
                  <!-- <div
                    class="custom-radio-icons-box"
                    *ngFor="let icon of icons; let i = index"
                  >
                    <input
                      type="radio"
                      class="custom-control-input"
                      [id]="'custom-icons' + i"
                      name="Logo"
                      [value]="iconBaseURL + icon"
                      formControlName="Logo"
                      (change)="changeLogo(); uriToFile(iconBaseURL + icon)"
                    />
                    <label
                      class="custom-control-label"
                      [for]="'custom-icons' + i"
                    >
                      <span class="custom-check-round">
                        <span class="img-thumb dark-back">
                          <img
                            [src]="iconBaseURL + icon"
                            class="img-fluid img-default-icon dark-back"
                            alt="default-icon"
                          />
                        </span>
                      </span>
                    </label>
                  </div> -->
                  <app-icons
                  class="w-100"  
                  fontSize="40"
                  height="350"
                  [form]="applicationForm"
                  >
                  </app-icons>
                </div>
              </div>
              <div class="or-div"><span class="text-or">or</span></div>
              <app-drag-upload
                title=""
                subTitle=""
                (value)="dragFileEvent($event)"
                mime="image/*"
                [clear]="clearDragUpload"
              ></app-drag-upload>
              <image-cropper
                [imageBase64]="imageChangedEvent"
                [maintainAspectRatio]="false"
                [aspectRatio]="4 / 4"
                [resizeToWidth]="256"
                format="png"
                (imageCropped)="imageCropped($event)"
              >
              </image-cropper>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer-bottom">
      <app-modal-action-btns
        [form]="applicationForm"
        (onReject)="close()"
        [disabled]="dragValue.invalid"
      ></app-modal-action-btns>
    </div>
  </form>
</div>
<div class="modal modal-small-custom fade" id="app-success-modal">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <!-- Modal body -->
      <div class="modal-body">
        <div class="modal-body-inner">
          <div class="row">
            <div class="col-lg-12 col-md-12">
              <div class="message-popup-box">
                <div class="thumb-div">
                  <img
                    src="assets/images/icons/thank-you.svg"
                    class="img-fluid img-thank-you"
                    alt="thank-you"
                  />
                </div>
                <div class="content-text-div">
                  <h2>Thank you!</h2>
                  <p class="text-italic">
                    Application Was Successfully Created!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<button
  type="button"
  #openSuccess
  class="d-none"
  id="openSuccessModal"
  data-toggle="modal"
  data-target="#app-success-modal"
  data-dismiss="modal"
>
  Open success
</button>
